import { get } from "lodash";
import moment from "moment";
import { RoomInfoPerson } from "src/interfaces";
import {
  QUERY_STRING_SEARCH_NUMBER_ADULT,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER,
  QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER,
} from "src/interfaces/defineQueryStringProperties";
import { listWeekShort } from "src/utils/list-week-short";
import { Option } from "./types";
import i18n from "src/utils/i18n";
import { ELanguage } from "src/interfaces";

export const EmailRegex =
  // eslint-disable-next-line no-useless-escape
  /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export const PassRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;

export const formatDateChoosed = (date: Date) => {
  const language = localStorage.getItem("lang");
  const format = language === ELanguage.EN ? "MM-DD" : "M月D日";

  const listWeekShortData = listWeekShort();
  const date1 = moment(date).format(format);
  return date1 + `(${listWeekShortData[moment(date).weekday()]})`;
};

export const totalChildren = (
  key: string,
  value: number,
  room: RoomInfoPerson
) => {
  const oldValue = Object.keys(room)
    .filter((e) => e !== key && e !== "childrens" && e !== "adult")
    .reduce((p, c) => p + Number(get(room, c)), 0);
  if (key !== "childrens" && key !== "adult") return oldValue + value;
  return room.childrens;
};

export const listAdultOption: () => Option[] = () => [
  { label: i18n.t("common.adultOptions", { number: 1 }), value: 1 },
  { label: i18n.t("common.adultOptions", { number: 2 }), value: 2 },
  { label: i18n.t("common.adultOptions", { number: 3 }), value: 3 },
  { label: i18n.t("common.adultOptions", { number: 4 }), value: 4 },
  { label: i18n.t("common.adultOptions", { number: 5 }), value: 5 },
  { label: i18n.t("common.adultOptions", { number: 6 }), value: 6 },
  { label: i18n.t("common.adultOptions", { number: 7 }), value: 7 },
  { label: i18n.t("common.adultOptions", { number: 8 }), value: 8 },
  { label: i18n.t("common.adultOptions", { number: 9 }), value: 9 },
];

export const listRoomOption: () => Option[] = () => [
  { label: i18n.t("common.roomOptions", { number: 1 }), value: 1 },
  { label: i18n.t("common.roomOptions", { number: 2 }), value: 2 },
  { label: i18n.t("common.roomOptions", { number: 3 }), value: 3 },
  { label: i18n.t("common.roomOptions", { number: 4 }), value: 4 },
  { label: i18n.t("common.roomOptions", { number: 5 }), value: 5 },
  { label: i18n.t("common.roomOptions", { number: 6 }), value: 6 },
  { label: i18n.t("common.roomOptions", { number: 7 }), value: 7 },
  { label: i18n.t("common.roomOptions", { number: 8 }), value: 8 },
  { label: i18n.t("common.roomOptions", { number: 9 }), value: 9 },
  { label: i18n.t("common.roomOptions", { number: 10 }), value: 10 },
];

export const listTypeChild: string[] = [
  "upper_student_upper",
  "lower_student_upper",
  "infants_1",
  "infants_2",
  "infants_3",
  "infants_4",
];

export const listHoliday: string[] = [
  "01-01",
  "12-02",
  "23-02",
  "20-03",
  "29-04",
  "03-05",
  "04-05",
  "05-05",
  "20-07",
  "11-08",
  "18-09",
  "23-09",
  "09-10",
  "03-11",
  "23-11",
  "23-12",
];

export const isOverPeople = (query: any): boolean => {
  let total = 0;
  if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER]);
  }
  if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER]);
  }
  if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1]);
  }
  if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2]);
  }
  if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3]);
  }
  if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4]);
  }
  if (query[QUERY_STRING_SEARCH_NUMBER_ADULT]) {
    total += Number(query[QUERY_STRING_SEARCH_NUMBER_ADULT]);
  }
  return total > 9;
};

export function formatPhone(x: string) {
  if (x) {
    return x.replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/, (match, p1, p2, p3) => {
      let formattedNumber = p1;
      if (p2) {
        formattedNumber += `-${p2}`;
      }
      if (p3) {
        formattedNumber += `-${p3}`;
      }
      return formattedNumber;
    });
  }

  return;
}

export const countTotalChildrenExtension = (query: any) => {
  let total = 0;
  const obj = {
    student_1: 0,
    student_2: 0,
    infants_1: 0,
    infants_2: 0,
    infants_3: 0,
    infants_4: 0,
  };

  if (query) {
    if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER]) {
      total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER]);
      obj["student_1"] = Number(
        query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_UPPER]
      );
    }
    if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER]) {
      total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER]);
      obj["student_2"] = Number(
        query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_STUDENT_LOWER]
      );
    }
    if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1]) {
      total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1]);
      obj["infants_1"] = Number(
        query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_1]
      );
    }
    if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2]) {
      total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2]);
      obj["infants_2"] = Number(
        query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_2]
      );
    }
    if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3]) {
      total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3]);
      obj["infants_3"] = Number(
        query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_3]
      );
    }
    if (query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4]) {
      total += Number(query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4]);
      obj["infants_4"] = Number(
        query[QUERY_STRING_SEARCH_NUMBER_SCHOOL_INFANTS_4]
      );
    }
  }

  return { total, obj };
};

export const scrollToIdElement = (id: string) => {
  const element = document.getElementById(id);
  if (!element) return;
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const offsetTop = rect.top + scrollTop - 100;
  const offsetLeft = rect.left + scrollLeft;
  window.scrollTo({
    top: offsetTop,
    left: offsetLeft,
    behavior: "smooth",
  });
};
